import { createAsyncThunk } from '@reduxjs/toolkit'
import { H_DISTRIBUTION_MODULE } from 'account/constants/AccessRulesConstants'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'
import { isAuthorized } from 'utils/HabilitationUtil'

const DistributionUnitThunk = {
    fetchDistributionUnits: createAsyncThunk(
        'fetchDistributionUnits',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(ApplicationConf.distributionUnit.getAll(), 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.distributionUnits} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.distributionUnits}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                if (!isAuthorized(H_DISTRIBUTION_MODULE, state)) {
                    return false
                }
                const { distributionUnitsStatus } = state.DataManagerReducer.distributionUnit
                if (arg.forceFetch) {
                    return distributionUnitsStatus !== REJECTED
                }
                return distributionUnitsStatus === IDLE
            },
            dispatchConditionRejection: true,
        },
    ),
}

export default DistributionUnitThunk